'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@/shared/providers';
import { registrarAcao } from '@/shared/utils/reportAction';
import { useAppSelector } from '@/store/hooks';
import { mensagemDoBloqueio } from '../estadoCriacao';
import { selectEstadoCriacao, selectPodeCriarLoteArbitral } from '../store/selectors';
import type { OrigemBloqueioCriacao } from '../types';

/**
 * Aplica a regra única de criação de processo arbitral numa tela: devolve o estado e a
 * mensagem, e `barrarCriacao` avisa a pessoa e registra a telemetria quando a criação não
 * pode seguir. Sem convênio não barra: o processo nasce com custa avulsa.
 */
export function useBloqueioCriacaoArbitral() {
  const $ = _c(13);
  const {
    showError,
    showWarning
  } = useToast();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = selectEstadoCriacao("ARBITRAGEM");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const estado = useAppSelector(t0);
  const podeCriarEmLote = useAppSelector(selectPodeCriarLoteArbitral);
  let t1;
  if ($[1] !== estado) {
    t1 = estado === "LIVRE" ? null : mensagemDoBloqueio(estado, "ARBITRAGEM");
    $[1] = estado;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const bloqueio = t1;
  let t2;
  if ($[3] !== bloqueio || $[4] !== estado || $[5] !== showError || $[6] !== showWarning) {
    t2 = origem => {
      if (!bloqueio) {
        return false;
      }
      registrarAcao("arbitral.criacao.bloqueada", {
        estadoCriacao: estado,
        origem
      });
      const avisar = bloqueio.tom === "aviso" ? showWarning : showError;
      avisar(bloqueio.titulo, bloqueio.descricao);
      return true;
    };
    $[3] = bloqueio;
    $[4] = estado;
    $[5] = showError;
    $[6] = showWarning;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const barrarCriacao = t2;
  let t3;
  if ($[8] !== barrarCriacao || $[9] !== bloqueio || $[10] !== estado || $[11] !== podeCriarEmLote) {
    t3 = {
      estado,
      bloqueio,
      podeCriarEmLote,
      barrarCriacao
    };
    $[8] = barrarCriacao;
    $[9] = bloqueio;
    $[10] = estado;
    $[11] = podeCriarEmLote;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}